module.exports = __webpack_public_path__ + "static/media/bsm-logo.b3a0243a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bsm-logo.png
// module id = 281
// module chunks = 0